<template>
  <div>
    <Imports type="products" />
  </div>
</template>

<script
  setup
  lang="ts"
>
import Imports from '@/modules/_shared/imports/index.vue';
</script>
